class Carte {
    constructor(rootEl) {
        this.rootEl = rootEl;
        this.tooltipEl;
        this.regionEls;
        this.regions = {};
        this.regionEls = this.rootEl.querySelectorAll(
            '.carte__region:not(.carte__region--disabled)'
        );

        this.regionEls.forEach((regionEl) => {
            const newRegion = new CarteRegion(this, regionEl);
            this.regions[newRegion.id] = newRegion;
        });

        this.tooltip = null;
        this.tooltipEnabled = this.rootEl.classList.contains('carte--tooltip');

        if (this.tooltipEnabled) {
            this.tooltip = new CarteTooltip(this);
            console.log(this.tooltip);
        }

        this.rootEl.addEventListener('carteHoverRegion', this.onRegionHover.bind(this));
        this.rootEl.addEventListener('carteClicRegion', this.onRegionClick.bind(this)); // Ajout de l'écouteur de clic
    }

    getPositionOnPage() {
        const boundingClientRect = this.rootEl.getBoundingClientRect();

        return {
            x: boundingClientRect.x + window.scrollX,
            y: boundingClientRect.y + window.scrollY
        };
    }

    onRegionHover(event) {
        const regionId = event.detail.region.id;
        console.log('Region ' + regionId + ' hovered');
    }

    onRegionClick(event) {
        // Méthode pour gérer le clic
        const regionId = event.detail.region.id;
        console.log('Region ' + regionId + ' clicked');
    }
}

class CarteRegion {
    constructor(parentCarte, regionEl) {
        this.parentCarte = parentCarte;
        this.rootEl = regionEl;
        this.id = this.rootEl.getAttribute('data-area-id');
        this.name = this.rootEl.getAttribute('data-area-name');
        this.city = this.rootEl.getAttribute('data-area-city');
        this.cityEl = this.rootEl.querySelector('.carte__ville');
        this.regionInfoEl = document.querySelector('div[data-region-id="' + this.id + '"]');

        // Survol de l'élément de la carte
        this.rootEl.addEventListener('mouseover', () => {
            this._activateRegion();
            this._toggleView(true);
        });

        this.rootEl.addEventListener('mouseout', () => {
            this._deactivateRegion();
            this._toggleView(false);
        });

        this.rootEl.addEventListener('click', () => {
            this._triggerClickEvent();
        });

        // Survol de l'élément d'information
        if (this.regionInfoEl) {
            this.regionInfoEl.addEventListener('mouseover', () => {
                this._activateRegion();
                this._toggleView(true);
            });

            this.regionInfoEl.addEventListener('mouseout', () => {
                this._toggleView(false);
            });
        }
    }

    _activateRegion() {
        const regionId = this.id;
        this.parentCarte.rootEl.dispatchEvent(
            new CustomEvent('carteHoverRegion', { detail: { region: { id: regionId } } })
        );

        if (this.regionInfoEl) {
            this.regionInfoEl.classList.add('regionHover');
        }

        if (this.rootEl) {
            this.rootEl.classList.add('activeRegion');
        }
    }

    _deactivateRegion() {
        if (this.regionInfoEl) {
            this.regionInfoEl.classList.remove('regionHover');
        }

        if (this.rootEl) {
            this.rootEl.classList.remove('activeRegion');
        }
    }

    _triggerClickEvent() {
        const regionId = this.id;
        this.parentCarte.rootEl.dispatchEvent(
            new CustomEvent('carteClicRegion', { detail: { region: { id: regionId } } })
        );
    }

    _toggleView(isView) {
        const contentId = this.id; // Assurez-vous que contentId est défini correctement
        this.viewContent = document.getElementById(contentId);

        if (isView) {
            this.viewContent.style.display = 'block'; // Correction de l'utilisation de style.display
        } else {
            this.viewContent.style.display = 'none';
        }
    }

    getLocationPositionOnPage() {
        const boundingClientRect = this.cityEl.getBoundingClientRect();
        const parentCarteBoundingClientRect = this.parentCarte.getPositionOnPage();

        return {
            x: boundingClientRect.x + window.scrollX - parentCarteBoundingClientRect.x + 5,
            y: boundingClientRect.y + window.scrollY - parentCarteBoundingClientRect.y
        };
    }
}

class CarteTooltip {
    constructor(parentCarte) {
        this.parentCarte = parentCarte;

        this.rootEl = document.createElement('div');
        this.rootEl.classList.add('carte__tooltip');
        this.rootEl.style.display = 'none';

        this.parentCarte.rootEl.insertAdjacentElement('afterend', this.rootEl);

        this.paragraphEl = document.createElement('p');
        this.paragraphEl.classList.add('carte__tooltipParagraph');

        this.rootEl.append(this.paragraphEl);

        this.parentCarte.rootEl.addEventListener('carteHoverRegion', (e) => {
            this.setCurrentRegion(this.parentCarte.regions[e.detail.region.id]);
        });
    }

    setText(textHTML) {
        this.paragraphEl.innerHTML = textHTML;
    }

    setPosition(x, y) {
        this.rootEl.style.left = x + 'px';
        this.rootEl.style.top = y + 'px';
        this.rootEl.style.display = 'block';
    }

    setCurrentRegion(region) {
        if (!region) return;
        const locationPositionOnPage = region.getLocationPositionOnPage();
        this.setText(
            '<span class="carte__nomLocalisation">' +
                region.name +
                '</span><br><span class="carte__nomVille">' +
                region.city +
                '</span>'
        );
        this.setPosition(locationPositionOnPage.x, locationPositionOnPage.y);
    }
}

//console.log('test carte.js');
